import platform from "../../assets/svg/platform.svg";
const Layout = () => import("@/layout/index.vue");

export default {
  path: "/jushu_platform",
  redirect: "/jushu_platform/index",
  name: "jushu_platform_index",
  component: Layout,
  meta: {
    icon: platform,
    title: "聚数平台",
    rank: 5
  },
  children: [
    {
      path: "index", 
      name: "jushu_platform_home",
      component: () => import("@/views/jushuPlatform/index.vue"),
      meta: {
        title: "聚数平台",
        keepAlive: false,
        roles: []
      }
    }
  ]
} as RouteConfigsTable;
